import Separator from "../Separator/Separator";

const LayoutSection = ({ children }) => {
  return (
    <div>
      {children} <Separator />
    </div>
  );
};

export default LayoutSection;
